<template>
  <div class="notify-manage">
    <div class="container-fluid py-4">
      <h2 class="h4 fw-medium mb-4">{{ $t('__generalSettings') }}</h2>

      <b-card class="mt-3">

      <b-tabs v-model="activeTab" card>
        <!-- 通用設定（合併版） -->
        <b-tab :title="$t('__commonSettings') || '通用設定'">
          <b-form @submit.prevent="saveAllSettings">
            <!-- 睡眠判斷設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-bed mr-2"></i>
              {{ $t('__sleepSettings') }}
            </h6>
            <b-row>
              <b-col md="3">
                <b-form-group
                  :label="$t('__severeLackHours') + ` (${$t('__unitHours')})`"
                  :description="$t('__severeLackHoursDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.sleep_severe_lack_hours"
                    type="number"
                    min="1"
                    max="24"
                    step="0.5"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group
                  :label="$t('__mildLackHours') + ` (${$t('__unitHours')})`"
                  :description="$t('__mildLackHoursDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.sleep_mild_lack_hours"
                    type="number"
                    min="1"
                    max="24"
                    step="0.5"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group
                  :label="$t('__mildExcessHours') + ` (${$t('__unitHours')})`"
                  :description="$t('__mildExcessHoursDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.sleep_mild_excess_hours"
                    type="number"
                    min="1"
                    max="24"
                    step="0.5"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group
                  :label="$t('__severeExcessHours') + ` (${$t('__unitHours')})`"
                  :description="$t('__severeExcessHoursDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.sleep_severe_excess_hours"
                    type="number"
                    min="1"
                    max="24"
                    step="0.5"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>


            <hr class="my-4">

            <!-- 量測時段設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-clock mr-2"></i>
              {{ $t('__measureTimeSettings') }}
            </h6>
            <b-row class="mb-4">
              <b-col md="3">
                <b-form-group
                  :label="$t('__morningTime') + ` (${$t('__unitHour')})`"
                  :description="$t('__morningTimeDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.default_morning_time"
                    type="number"
                    min="0"
                    max="23"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__afternoonTime') + ` (${$t('__unitHour')})`"
                  :description="$t('__afternoonTimeDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.default_afternoon_time"
                    type="number"
                    min="0"
                    max="23"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__nightTime') + ` (${$t('__unitHour')})`"
                  :description="$t('__nightTimeDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.default_night_time"
                    type="number"
                    min="0"
                    max="23"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__midnightTime') + ` (${$t('__unitHour')})`"
                  :description="$t('__midnightTimeDesc')"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.default_midnight_time"
                    type="number"
                    min="0"
                    max="23"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 量測時段 -->
            <b-row class="mb-4">
              <b-col md="12">
                <b-form-group
                  :label="$t('__measurePeriodsLabel')"
                  :description="$t('__measurePeriodsDesc')"
                  class="mb-3"
                >
                  <v-select
                    v-model="globalMeasurePeriodsArray"
                    :options="periodOptions"
                    multiple
                    :placeholder="$t('__selectMeasurePeriods')"
                    class="style-chooser"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 設備設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-stethoscope mr-2"></i>
              {{ $t('__deviceSettings') }}
            </h6>
            <b-row class="mb-4">
              <b-col md="6">
                <b-form-group
                  :label="$t('__allDevices')"
                  :description="$t('__allDevicesDesc')"
                  class="mb-3"
                >
                  <v-select
                    v-model="globalAllDevicesArray"
                    :options="deviceOptions"
                    multiple
                    :placeholder="$t('__selectDeviceTypes')"
                    class="style-chooser"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('__defaultDevices')"
                  :description="$t('__defaultDevicesDesc')"
                  class="mb-3"
                >
                  <v-select
                    v-model="globalDefaultDevicesArray"
                    :options="deviceOptions"
                    multiple
                    :placeholder="$t('__selectDeviceTypes')"
                    class="style-chooser"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 血壓設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-heartbeat mr-2"></i>
              {{ $t('__bloodPressureSettings') }}
            </h6>
            <b-row class="mb-4">
              <b-col md="3">
                <b-form-group
                  :label="$t('__sbpLowerBound') + ` (${$t('__unitMmHg')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.sbp_lower_bound"
                    type="number"
                    min="50"
                    max="200"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__sbpUpperBound') + ` (${$t('__unitMmHg')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.sbp_upper_bound"
                    type="number"
                    min="50"
                    max="250"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__dbpLowerBound') + ` (${$t('__unitMmHg')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.dbp_lower_bound"
                    type="number"
                    min="30"
                    max="150"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__dbpUpperBound') + ` (${$t('__unitMmHg')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.dbp_upper_bound"
                    type="number"
                    min="30"
                    max="150"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-4">
              <b-col md="4">
                <b-form-group
                  :label="$t('__bpPulseLowerBound') + ` (${$t('__unitBpm')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.bp_pulse_lower_bound"
                    type="number"
                    min="30"
                    max="200"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('__bpPulseUpperBound') + ` (${$t('__unitBpm')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.bp_pulse_upper_bound"
                    type="number"
                    min="30"
                    max="200"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 體溫設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-thermometer-half mr-2"></i>
              {{ $t('__temperatureSettings') }}
            </h6>
            <b-row class="mb-4">
              <b-col md="4">
                <b-form-group
                  :label="$t('__tempLowerBound') + ` (${$t('__unitCelsius')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.temp_lower_bound"
                    type="number"
                    min="30"
                    max="45"
                    step="0.1"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('__tempUpperBound') + ` (${$t('__unitCelsius')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.temp_upper_bound"
                    type="number"
                    min="30"
                    max="45"
                    step="0.1"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 血氧設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-lungs mr-2"></i>
              {{ $t('__spo2Settings') }}
            </h6>
            <b-row class="mb-4">
              <b-col md="3">
                <b-form-group
                  :label="$t('__spo2LowerBound') + ` (${$t('__unitPercent')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.spo2_lower_bound"
                    type="number"
                    min="50"
                    max="100"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__spo2PulseLowerBound') + ` (${$t('__unitBpm')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.spo2_pulse_lower_bound"
                    type="number"
                    min="30"
                    max="200"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$t('__spo2PulseUpperBound') + ` (${$t('__unitBpm')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.spo2_pulse_upper_bound"
                    type="number"
                    min="30"
                    max="200"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 血糖設定 -->
            <h6 class="mb-3 text-primary">
              <i class="fas fa-tint mr-2"></i>
              {{ $t('__glucoseSettings') }}
            </h6>
            <b-row class="mb-4">
              <b-col md="4">
                <b-form-group
                  :label="$t('__gluLowerBound') + ` (${$t('__unitMgDl')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.glu_lower_bound"
                    type="number"
                    min="20"
                    max="600"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('__gluUpperBound') + ` (${$t('__unitMgDl')})`"
                  class="mb-3"
                >
                  <b-form-input
                    v-model.number="globalSettings.glu_upper_bound"
                    type="number"
                    min="20"
                    max="600"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="d-flex justify-content-end mt-4">
              <b-button type="button" variant="secondary" @click="loadAllSettings">
                <i class="fas fa-undo mr-1"></i>
                {{ $t('__reset') }}
              </b-button>
              <b-button type="submit" variant="primary" class="ml-3" style="margin-left: 10px;">
                <i class="fas fa-save mr-1"></i>
                {{ $t('__save') }}
              </b-button>
            </div>
          </b-form>
        </b-tab>

        <!-- 個人設定 -->
        <b-tab :title="$t('__personalSettings')">
          <!-- 搜尋住民 -->
          <div class="mb-4">
            <h6 class="mb-3 text-primary">
              <i class="fas fa-search mr-2"></i>
              {{ $t('__searchResident') }}
            </h6>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('__residentNameLabel')"
                  class="mb-3"
                >
                  <div class="d-flex">
                    <b-form-input
                      v-model="residentSearch"
                      :placeholder="$t('__searchResidentPlaceholder')"
                      @keyup.enter="searchResident"
                      class="mr-2"
                    ></b-form-input>
                    <b-button variant="primary" @click="searchResident" style="margin-left: 10px; width: 110px;">
                      {{ $t('__search') }}
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- 搜尋結果 -->
            <div v-if="searchResults.length > 0" class="mt-3">
              <b-list-group>
                <b-list-group-item
                  v-for="resident in searchResults"
                  :key="resident.id"
                  button
                  @click="selectResident(resident)"
                  :active="selectedResident && selectedResident.id === resident.id"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <span>
                      <i class="fas fa-user mr-2"></i>
                      {{ resident.name }}
                      <b-badge v-if="resident.bed_number" variant="secondary" class="ml-2">
                        {{ $t('__bedNumber') }}：{{ resident.bed_number }}
                      </b-badge>
                    </span>
                    <b-badge v-if="resident.agency_name" variant="info">
                      {{ resident.agency_name }}
                    </b-badge>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>

            <!-- 無搜尋結果 -->
            <div v-else-if="hasSearched && searchResults.length === 0" class="mt-3">
              <b-alert show variant="warning">
                <i class="fas fa-exclamation-triangle mr-1"></i>
                {{ $t('__noMatchingResident') }}
              </b-alert>
            </div>
          </div>

          <!-- 個人設定表單 -->
          <div v-if="selectedResident" class="mt-4">
            <b-card>
              <template #header>
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">
                    <i class="fas fa-user-cog mr-2"></i>
                    {{ $t('__personalSettingsFor', { name: selectedResident.name }) }}
                  </h6>
                  <b-button size="sm" variant="outline-secondary" @click="clearSelectedResident">
                    <i class="fas fa-times"></i>
                    {{ $t('__clearSelection') }}
                  </b-button>
                </div>
              </template>

              <b-form @submit.prevent="savePersonalSettings">
                <!-- 提示訊息 -->
                <b-alert show variant="info" class="mb-4">
                  <i class="fas fa-info-circle mr-1"></i>
                  {{ $t('__personalSettingsHint') }}
                </b-alert>

                <!-- 睡眠判斷設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-bed mr-2"></i>
                  {{ $t('__sleepSettings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__severeLackHours') + ` (${$t('__unitHours')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.sleep_severe_lack_hours} ${$t('__unitHours')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.sleep_severe_lack_hours"
                        type="number"
                        min="1"
                        max="24"
                        step="0.5"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__mildLackHours') + ` (${$t('__unitHours')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.sleep_mild_lack_hours} ${$t('__unitHours')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.sleep_mild_lack_hours"
                        type="number"
                        min="1"
                        max="24"
                        step="0.5"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__mildExcessHours') + ` (${$t('__unitHours')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.sleep_mild_excess_hours} ${$t('__unitHours')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.sleep_mild_excess_hours"
                        type="number"
                        min="1"
                        max="24"
                        step="0.5"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__severeExcessHours') + ` (${$t('__unitHours')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.sleep_severe_excess_hours} ${$t('__unitHours')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.sleep_severe_excess_hours"
                        type="number"
                        min="1"
                        max="24"
                        step="0.5"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 量測時段設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-clock mr-2"></i>
                  {{ $t('__measureTimeSettings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__morningTime') + ` (${$t('__unitHour')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.default_morning_time} ${$t('__unitHour')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.default_morning_time"
                        type="number"
                        min="0"
                        max="23"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__afternoonTime') + ` (${$t('__unitHour')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.default_afternoon_time} ${$t('__unitHour')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.default_afternoon_time"
                        type="number"
                        min="0"
                        max="23"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__nightTime') + ` (${$t('__unitHour')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.default_night_time} ${$t('__unitHour')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.default_night_time"
                        type="number"
                        min="0"
                        max="23"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__midnightTime') + ` (${$t('__unitHour')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.default_midnight_time} ${$t('__unitHour')}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.default_midnight_time"
                        type="number"
                        min="0"
                        max="23"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 量測時段 -->
                <b-row class="mb-4">
                  <b-col md="12">
                    <b-form-group
                      :label="$t('__measurePeriodsLabel')"
                      :description="`${$t('__globalSetting')}：${globalSettings.default_measure_periods}`"
                      class="mb-3"
                    >
                      <v-select
                        v-model="personalMeasurePeriodsArray"
                        :options="periodOptions"
                        multiple
                        :placeholder="$t('__useGlobalSettings')"
                        class="style-chooser"
                        :clearable="true"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 設備設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-stethoscope mr-2"></i>
                  {{ $t('__deviceSettings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="6">
                    <b-form-group
                      :label="$t('__allDevices')"
                      :description="`${$t('__globalSetting')}：${globalSettings.all_devices}`"
                      class="mb-3"
                    >
                      <v-select
                        v-model="personalAllDevicesArray"
                        :options="deviceOptions"
                        multiple
                        :placeholder="$t('__useGlobalSettings')"
                        class="style-chooser"
                        :clearable="true"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('__defaultDevices')"
                      :description="`${$t('__globalSetting')}：${globalSettings.default_devices}`"
                      class="mb-3"
                    >
                      <v-select
                        v-model="personalDefaultDevicesArray"
                        :options="deviceOptions"
                        multiple
                        :placeholder="$t('__useGlobalSettings')"
                        class="style-chooser"
                        :clearable="true"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 血壓設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-heartbeat mr-2"></i>
                  {{ $t('__bloodPressureSettings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__sbpLowerBound') + ` (${$t('__unitMmHg')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.sbp_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.sbp_lower_bound"
                        type="number"
                        min="50"
                        max="200"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__sbpUpperBound') + ` (${$t('__unitMmHg')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.sbp_upper_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.sbp_upper_bound"
                        type="number"
                        min="50"
                        max="250"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__dbpLowerBound') + ` (${$t('__unitMmHg')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.dbp_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.dbp_lower_bound"
                        type="number"
                        min="30"
                        max="150"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__dbpUpperBound') + ` (${$t('__unitMmHg')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.dbp_upper_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.dbp_upper_bound"
                        type="number"
                        min="30"
                        max="150"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="mb-4">
                  <b-col md="4">
                    <b-form-group
                      :label="$t('__bpPulseLowerBound') + ` (${$t('__unitBpm')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.bp_pulse_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.bp_pulse_lower_bound"
                        type="number"
                        min="30"
                        max="200"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                      :label="$t('__bpPulseUpperBound') + ` (${$t('__unitBpm')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.bp_pulse_upper_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.bp_pulse_upper_bound"
                        type="number"
                        min="30"
                        max="200"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 體溫設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-thermometer-half mr-2"></i>
                  {{ $t('__temperatureSettings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__tempLowerBound') + ` (${$t('__unitCelsius')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.temp_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.temp_lower_bound"
                        type="number"
                        min="30"
                        max="45"
                        step="0.1"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__tempUpperBound') + ` (${$t('__unitCelsius')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.temp_upper_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.temp_upper_bound"
                        type="number"
                        min="30"
                        max="45"
                        step="0.1"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 血氧設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-lungs mr-2"></i>
                  {{ $t('__spo2Settings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__spo2LowerBound') + ` (${$t('__unitPercent')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.spo2_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.spo2_lower_bound"
                        type="number"
                        min="50"
                        max="100"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__spo2PulseLowerBound') + ` (${$t('__unitBpm')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.spo2_pulse_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.spo2_pulse_lower_bound"
                        type="number"
                        min="30"
                        max="200"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__spo2PulseUpperBound') + ` (${$t('__unitBpm')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.spo2_pulse_upper_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.spo2_pulse_upper_bound"
                        type="number"
                        min="30"
                        max="200"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 血糖設定 -->
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-tint mr-2"></i>
                  {{ $t('__glucoseSettings') }}
                </h6>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__gluLowerBound') + ` (${$t('__unitMgDl')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.glu_lower_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.glu_lower_bound"
                        type="number"
                        min="20"
                        max="600"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('__gluUpperBound') + ` (${$t('__unitMgDl')})`"
                      :description="`${$t('__globalSetting')}：${globalSettings.glu_upper_bound}`"
                      class="mb-3"
                    >
                      <b-form-input
                        v-model.number="personalSettings.glu_upper_bound"
                        type="number"
                        min="20"
                        max="600"
                        :placeholder="$t('__useGlobal')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- 操作按鈕 -->
                <div class="d-flex justify-content-end">
                  <b-button type="button" variant="outline-danger" @click="resetPersonalSettings">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    {{ $t('__clearAllUseGlobal') }}
                  </b-button>
                  <b-button type="submit" variant="primary" class="ml-3" style="margin-left: 10px;">
                    <i class="fas fa-save mr-1"></i>
                    {{ $t('__savePersonalSettings') }}
                  </b-button>
                </div>
              </b-form>
            </b-card>
          </div>

          <!-- 未選擇住民時的提示 -->
          <div v-else-if="!hasSearched" class="text-center py-5">
            <i class="fas fa-user-cog fa-3x text-muted mb-3"></i>
            <p class="text-muted">
              {{ $t('__searchResidentHint') }}
            </p>
            <p class="text-muted">
              {{ $t('__personalOverrideHint') }}
            </p>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    </div>
  </div>
</template>

<script>
import { generalSetting } from '@/http/api/generalSetting'
import { personalSetting } from '@/http/api/personalSetting'
import { mapState, mapMutations } from 'vuex'
import i18n from '@/lang/lang.js'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'GeneralSettings',
  components: {
    vSelect
  },
  data() {
    return {
      activeTab: 0,

      // 全域設定（合併版）
      globalSettings: {
        // 睡眠設定
        sleep_severe_lack_hours: 4,
        sleep_mild_lack_hours: 6,
        sleep_mild_excess_hours: 10,
        sleep_severe_excess_hours: 12,
        // 時段設定
        default_morning_time: 10,
        default_afternoon_time: 16,
        default_night_time: 21,
        default_midnight_time: 6,
        default_measure_periods: '早上,下午,晚上',

        // 設備設定
        all_devices: '血壓計,體溫計,血氧機,血糖機',
        default_devices: '血壓計,體溫計,血氧機',

        // 血壓
        sbp_lower_bound: 90,
        sbp_upper_bound: 140,
        dbp_lower_bound: 60,
        dbp_upper_bound: 90,
        bp_pulse_lower_bound: 60,
        bp_pulse_upper_bound: 100,

        // 體溫
        temp_lower_bound: 35.5,
        temp_upper_bound: 37.5,

        // 血氧
        spo2_lower_bound: 95,
        spo2_pulse_lower_bound: 60,
        spo2_pulse_upper_bound: 100,

        // 血糖
        glu_lower_bound: 70,
        glu_upper_bound: 140
      },

      // 選項陣列
      deviceOptions: ['血壓計', '體溫計', '血氧機', '血糖機'],
      periodOptions: ['早上', '下午', '晚上', '午夜'],

      // 個人設定相關
      residentSearch: '',
      hasSearched: false,
      searchResults: [],
      selectedResident: null,
      personalSettings: {
        // 睡眠設定
        sleep_severe_lack_hours: null,
        sleep_mild_lack_hours: null,
        sleep_mild_excess_hours: null,
        sleep_severe_excess_hours: null,

        // 時段設定
        default_morning_time: null,
        default_afternoon_time: null,
        default_night_time: null,
        default_midnight_time: null,
        default_measure_periods: null,

        // 設備設定
        all_devices: null,
        default_devices: null,

        // 血壓
        sbp_lower_bound: null,
        sbp_upper_bound: null,
        dbp_lower_bound: null,
        dbp_upper_bound: null,
        bp_pulse_lower_bound: null,
        bp_pulse_upper_bound: null,

        // 體溫
        temp_lower_bound: null,
        temp_upper_bound: null,

        // 血氧
        spo2_lower_bound: null,
        spo2_pulse_lower_bound: null,
        spo2_pulse_upper_bound: null,

        // 血糖
        glu_lower_bound: null,
        glu_upper_bound: null
      }
    }
  },
  computed: {
    ...mapState(['token']),

    // 全域設定 - 計算屬性
    globalMeasurePeriodsArray: {
      get() {
        return this.globalSettings.default_measure_periods ?
          this.globalSettings.default_measure_periods.split(',').map(s => s.trim()) : []
      },
      set(value) {
        this.globalSettings.default_measure_periods = value.join(',')
      }
    },
    globalAllDevicesArray: {
      get() {
        return this.globalSettings.all_devices ?
          this.globalSettings.all_devices.split(',').map(s => s.trim()) : []
      },
      set(value) {
        this.globalSettings.all_devices = value.join(',')
      }
    },
    globalDefaultDevicesArray: {
      get() {
        return this.globalSettings.default_devices ?
          this.globalSettings.default_devices.split(',').map(s => s.trim()) : []
      },
      set(value) {
        this.globalSettings.default_devices = value.join(',')
      }
    },

    // 個人設定 - 計算屬性
    personalMeasurePeriodsArray: {
      get() {
        return this.personalSettings.default_measure_periods ?
          this.personalSettings.default_measure_periods.split(',').map(s => s.trim()) : []
      },
      set(value) {
        this.personalSettings.default_measure_periods = value && value.length > 0 ? value.join(',') : null
      }
    },
    personalAllDevicesArray: {
      get() {
        return this.personalSettings.all_devices ?
          this.personalSettings.all_devices.split(',').map(s => s.trim()) : []
      },
      set(value) {
        this.personalSettings.all_devices = value && value.length > 0 ? value.join(',') : null
      }
    },
    personalDefaultDevicesArray: {
      get() {
        return this.personalSettings.default_devices ?
          this.personalSettings.default_devices.split(',').map(s => s.trim()) : []
      },
      set(value) {
        this.personalSettings.default_devices = value && value.length > 0 ? value.join(',') : null
      }
    }
  },
  mounted() {
    this.loadAllSettings()
  },
  methods: {
    ...mapMutations(['Loading', 'Loaded', 'AlertsInfo', 'Alerted']),
    async loadAllSettings() {
      try {
        this.Loading()
        const response = await generalSetting.getAllSettings(this.token)

        if (response.status <= 201 && response.data.success) {
          Object.assign(this.globalSettings, response.data.data)
        } else {
          this.AlertsInfo({
            state: 'error',
            title: this.$t('__error'),
            info: response.data.message || this.$t('__loadSettingsFailed')
          })
          this.Alerted()
        }
        this.Loaded()
      } catch (error) {
        console.error('載入設定失敗:', error)
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__loadSettingsFailed')
        })
        this.Alerted()
        this.Loaded()
      }
    },

    async saveAllSettings() {
      // 驗證邏輯關係
      if (this.globalSettings.sleep_severe_lack_hours >= this.globalSettings.sleep_mild_lack_hours) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__severeLackMustLessThanMild')
        })
        this.Alerted()
        return
      }

      if (this.globalSettings.sleep_mild_excess_hours >= this.globalSettings.sleep_severe_excess_hours) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__mildExcessMustLessThanSevere')
        })
        this.Alerted()
        return
      }

      if (this.globalSettings.sbp_lower_bound >= this.globalSettings.sbp_upper_bound) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__sbpLowerMustLessThanUpper')
        })
        this.Alerted()
        return
      }

      if (this.globalSettings.dbp_lower_bound >= this.globalSettings.dbp_upper_bound) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__dbpLowerMustLessThanUpper')
        })
        this.Alerted()
        return
      }

      if (this.globalSettings.temp_lower_bound >= this.globalSettings.temp_upper_bound) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__tempLowerMustLessThanUpper')
        })
        this.Alerted()
        return
      }

      if (this.globalSettings.glu_lower_bound >= this.globalSettings.glu_upper_bound) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__gluLowerMustLessThanUpper')
        })
        this.Alerted()
        return
      }

      this.Loading()
      try {
        const response = await generalSetting.updateAllSettings(this.globalSettings, this.token)
        if (response.status <= 201 && response.data.success) {
          this.AlertsInfo({
            state: 'success',
            title: this.$t('__success'),
            info: this.$t('__settingsSavedSuccess')
          })
          this.Alerted()
          // 重新載入設定以確保顯示最新值
          await this.loadAllSettings()
        } else {
          this.AlertsInfo({
            state: 'error',
            title: this.$t('__error'),
            info: response.data.message || this.$t('__saveFailed')
          })
          this.Alerted()
        }
        this.Loaded()
      } catch (error) {
        console.error('儲存設定失敗:', error)
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__saveSettingsFailed')
        })
        this.Alerted()
        this.Loaded()
      }
    },

    // 個人設定相關方法
    async searchResident() {
      if (!this.residentSearch.trim()) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__pleaseEnterResidentName')
        })
        this.Alerted()
        return
      }

      this.Loading()
      try {
        this.hasSearched = true

        const response = await personalSetting.searchResidents(
          this.residentSearch,
          this.token
        )

        if (response.status <= 201 && response.data.status === 'success') {
          this.searchResults = response.data.data

          if (this.searchResults.length === 0) {
            this.AlertsInfo({
              state: 'warning',
              title: this.$t('__searchResult'),
              info: this.$t('__noMatchingResident')
            })
            this.Alerted()
          }
        } else {
          this.AlertsInfo({
            state: 'error',
            title: this.$t('__error'),
            info: response.data.errMsg || this.$t('__searchFailed')
          })
          this.Alerted()
        }
        this.Loaded()
      } catch (error) {
        console.error('搜尋住民失敗:', error)
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__searchFailed')
        })
        this.Alerted()
        this.Loaded()
      }
    },

    async selectResident(resident) {
      this.selectedResident = resident
      await this.loadPersonalSettings(resident.id)

      this.AlertsInfo({
        state: 'success',
        title: this.$t('__selected'),
        info: this.$t('__residentSelected', { name: resident.name })
      })
      this.Alerted()
    },

    async loadPersonalSettings(residentId, showLoading = true) {
      if (showLoading) {
        this.Loading()
      }

      try {
        const response = await personalSetting.getSettings(
          residentId,
          this.token
        )

        if (response.status <= 201 && response.data.status === 'success') {
          // 將返回的設定合併到 personalSettings，保留未設定的欄位為 null
          const settings = response.data.data || {}
          console.log('載入的個人設定:', settings)
          this.personalSettings = {
            // 睡眠設定
            sleep_severe_lack_hours: settings.sleep_severe_lack_hours || null,
            sleep_mild_lack_hours: settings.sleep_mild_lack_hours || null,
            sleep_mild_excess_hours: settings.sleep_mild_excess_hours || null,
            sleep_severe_excess_hours: settings.sleep_severe_excess_hours || null,
            // 時段設定
            default_morning_time: settings.default_morning_time || null,
            default_afternoon_time: settings.default_afternoon_time || null,
            default_night_time: settings.default_night_time || null,
            default_midnight_time: settings.default_midnight_time || null,
            default_measure_periods: settings.default_measure_periods !== undefined ? settings.default_measure_periods : null,
            // 設備設定
            all_devices: settings.all_devices !== undefined ? settings.all_devices : null,
            default_devices: settings.default_devices !== undefined ? settings.default_devices : null,
            // 生理數值
            sbp_lower_bound: settings.sbp_lower_bound || null,
            sbp_upper_bound: settings.sbp_upper_bound || null,
            dbp_lower_bound: settings.dbp_lower_bound || null,
            dbp_upper_bound: settings.dbp_upper_bound || null,
            bp_pulse_lower_bound: settings.bp_pulse_lower_bound || null,
            bp_pulse_upper_bound: settings.bp_pulse_upper_bound || null,
            temp_lower_bound: settings.temp_lower_bound || null,
            temp_upper_bound: settings.temp_upper_bound || null,
            spo2_lower_bound: settings.spo2_lower_bound || null,
            spo2_pulse_lower_bound: settings.spo2_pulse_lower_bound || null,
            spo2_pulse_upper_bound: settings.spo2_pulse_upper_bound || null,
            glu_lower_bound: settings.glu_lower_bound || null,
            glu_upper_bound: settings.glu_upper_bound || null
          }
        } else {
          if (showLoading) {
            this.AlertsInfo({
              state: 'error',
              title: this.$t('__error'),
              info: this.$t('__loadPersonalSettingsFailed')
            })
            this.Alerted()
          }
        }
        if (showLoading) {
          this.Loaded()
        }
      } catch (error) {
        console.error('載入個人設定失敗:', error)
        if (showLoading) {
          this.AlertsInfo({
            state: 'error',
            title: this.$t('__error'),
            info: this.$t('__loadPersonalSettingsFailed')
          })
          this.Alerted()
          this.Loaded()
        }
      }
    },

    clearSelectedResident() {
      this.selectedResident = null
      this.personalSettings = {
        // 睡眠設定
        sleep_severe_lack_hours: null,
        sleep_mild_lack_hours: null,
        sleep_mild_excess_hours: null,
        sleep_severe_excess_hours: null,
        // 時段設定
        default_morning_time: null,
        default_afternoon_time: null,
        default_night_time: null,
        default_measure_periods: null,
        // 設備設定
        all_devices: null,
        default_devices: null,
        // 生理數值
        sbp_lower_bound: null,
        sbp_upper_bound: null,
        dbp_lower_bound: null,
        dbp_upper_bound: null,
        bp_pulse_lower_bound: null,
        bp_pulse_upper_bound: null,
        temp_lower_bound: null,
        temp_upper_bound: null,
        spo2_lower_bound: null,
        spo2_pulse_lower_bound: null,
        spo2_pulse_upper_bound: null,
        glu_lower_bound: null,
        glu_upper_bound: null
      }
    },

    resetPersonalSettings() {
      // 二次確認：防止使用者誤刪個人設定
      if (!confirm('確定要清除所有個人設定並使用全域設定嗎？此操作無法復原。')) {
        return // 使用者取消，不執行清除
      }

      this.personalSettings = {
        // 睡眠設定
        sleep_severe_lack_hours: null,
        sleep_mild_lack_hours: null,
        sleep_mild_excess_hours: null,
        sleep_severe_excess_hours: null,
        // 時段設定
        default_morning_time: null,
        default_afternoon_time: null,
        default_night_time: null,
        default_measure_periods: null,
        // 設備設定
        all_devices: null,
        default_devices: null,
        // 生理數值
        sbp_lower_bound: null,
        sbp_upper_bound: null,
        dbp_lower_bound: null,
        dbp_upper_bound: null,
        bp_pulse_lower_bound: null,
        bp_pulse_upper_bound: null,
        temp_lower_bound: null,
        temp_upper_bound: null,
        spo2_lower_bound: null,
        spo2_pulse_lower_bound: null,
        spo2_pulse_upper_bound: null,
        glu_lower_bound: null,
        glu_upper_bound: null
      }

      this.AlertsInfo({
        state: 'info',
        title: this.$t('__cleared'),
        info: this.$t('__personalSettingsClearedInfo')
      })
      this.Alerted()
    },

    async savePersonalSettings() {
      if (!this.selectedResident) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__pleaseSelectResident')
        })
        this.Alerted()
        return
      }

      // 驗證邏輯
      if (this.personalSettings.sleep_severe_lack_hours &&
          this.personalSettings.sleep_mild_lack_hours &&
          this.personalSettings.sleep_severe_lack_hours >= this.personalSettings.sleep_mild_lack_hours) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__severeLackMustLessThanMild')
        })
        this.Alerted()
        return
      }

      if (this.personalSettings.sleep_mild_excess_hours &&
          this.personalSettings.sleep_severe_excess_hours &&
          this.personalSettings.sleep_mild_excess_hours >= this.personalSettings.sleep_severe_excess_hours) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__mildExcessMustLessThanSevere')
        })
        this.Alerted()
        return
      }

      this.Loading()
      try {
        // 只傳送有值的設定
        const dataToSave = {}
        for (const [key, value] of Object.entries(this.personalSettings)) {
          if (value !== null && value !== '') {
            dataToSave[key] = value
          }
        }

        console.log('準備儲存的個人設定:', dataToSave)

        const response = await personalSetting.updateSettings(
          this.selectedResident.id,
          dataToSave,
          this.token
        )

        if (response.status <= 201 && response.data.status === 'success') {
          // 顯示成功訊息
          this.AlertsInfo({
            state: 'success',
            title: this.$t('__success'),
            info: this.$t('__personalSettingsSavedSuccess', { name: this.selectedResident.name })
          })
          this.Alerted()

          // 重新載入個人設定，但不顯示 loading
          await this.loadPersonalSettings(this.selectedResident.id, false)
        } else {
          this.AlertsInfo({
            state: 'error',
            title: this.$t('__error'),
            info: response.data.errMsg || this.$t('__savePersonalSettingsFailed')
          })
          this.Alerted()
        }
        this.Loaded()
      } catch (error) {
        console.error('儲存個人設定失敗:', error)
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: this.$t('__savePersonalSettingsFailed')
        })
        this.Alerted()
        this.Loaded()
      }
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

h6 {
  color: #495057;
  font-weight: 600;
}
</style>
